/*
 * Copyright 2019 WeBank
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 *  you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 */

export default {
  register(monaco) {
    monaco.languages.register({ id: 'log' });

    monaco.languages.setMonarchTokensProvider('log', {
      tokenizer: {
        root: [
          [/(^[=a-zA-Z].*|\d\s.*)/, 'log-normal'],
          [/\sERROR\s.*/, 'log-error'],
          [/\sWARN\s.*/, 'log-warn'],
          [/\sINFO\s.*/, 'log-info'],
          [/^([0-9]{4}||[0-9]{2})-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}(.[0-9]{3})?/, 'log-date'],
          [/^[0-9]{2}\/[0-9]{2}\/[0-9]{2} [0-9]{2}:[0-9]{2}:[0-9]{2}(.[0-9]{3})?/, 'log-date'],
          [/(^\*\*Waiting queue:.*)/, 'log-info'],
          [/(^\*\*result tips:.*)/, 'log-info'],
        ],
      },
    });
  },
};
